import { CircularProgress, useMediaQuery } from "@mui/material";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function PartnersSkeleton() {
  const customHeight = 200;

  const isMobile = useMediaQuery("(max-width:600px)");

  const skeletonBoxStyle = {
    backgroundColor: "#fff",
    borderRadius: "2px",
    height: "250px",
    width: "100%",
    maxWidth: "150px", // This limits max width on larger screens
  };

  return (
    <div className="d-flex flex-column min-vh-100 gap-4 p-3 align-items-center ">
      {[...Array(2)].map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="d-flex  justify-content-center align-items-center gap-3 w-100"
        >
          {[...Array(isMobile ? 2 : 4)].map((_, colIndex) => (
            <div
              key={colIndex}
              className="w-100 d-md-flex justify-content-md-center"
              style={{ maxWidth: "100%" }}
            >
              <div
                style={{
                  ...skeletonBoxStyle,
                  width: "100%",
                  maxWidth: "300px",
                }}
              >
                <Skeleton
                  baseColor="#ddd"
                  highlightColor="#f5deb3"
                  width="100%"
                  height={customHeight}
                />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
